import { THEME } from "@/constants/localStorage";
import { useEffect, useState } from "react";

type Theme = "light" | "dark";

const getSystemTheme = (): Theme => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

const getInitialTheme = (): Theme => {
  const stored = localStorage.getItem(THEME) as Theme | null;
  if (stored === "light" || stored === "dark") return stored;
  return getSystemTheme();
};

export const useTheme = () => {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme());

  useEffect(() => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(theme);
  }, [theme]);

  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
    localStorage.setItem(THEME, newTheme);

    window.dispatchEvent(
      new StorageEvent("storage", {
        key: THEME,
        newValue: newTheme,
      }),
    );
  };

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === THEME && (event.newValue === "light" || event.newValue === "dark")) {
        setThemeState(event.newValue as Theme);
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return { theme, setTheme };
};
